/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/aoam-market-suggest.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/aoam-market-suggest.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
    (function () {
      var host = document.getElementById('aoam-mkt');
      var raw = document.getElementById('aoam-mkt-data');
      if (!host || !raw) return;

      var data;
      try { data = JSON.parse(raw.textContent); } catch (e) { return; }
      var KEY = 'aoam-mkt-dismissed';

      function dismissed(cc) {
        try { return (localStorage.getItem(KEY) || '').split(',').indexOf(cc) !== -1; } catch (e) { return false; }
      }
      function remember(cc) {
        try {
          var v = (localStorage.getItem(KEY) || '').split(',').filter(Boolean);
          if (v.indexOf(cc) === -1) v.push(cc);
          localStorage.setItem(KEY, v.join(','));
        } catch (e) {}
      }

      // Anything already pinned to the bottom of the viewport (the theme's SAVE 5% subscribe bar,
      // or the consent dialog if it is somehow still up) gets measured and this bar sits above it.
      function lift() {
        var max = 0;
        // 2026-10-10 audit: also lift above the pinned sticky Add to Cart (PDP) and the Kit Builder bottom bar, which this bar used to cover; a bar parked below the screen no longer counts (r.top check). Joel 2026-10-10: "ship any fixes/finds" (sitewide audit). Roll back: delete the two added selectors, the r.top test, liftSoon and the scroll add and remove lines.
        var els = document.querySelectorAll('#shopify-section-subscribe-form, #shopify-pc__banner, .shopify-pc__banner, .sticky-add-to-cart-btn.is-sticky, #kb6 .bb');
        for (var i = 0; i < els.length; i++) {
          var e = els[i], cs = getComputedStyle(e);
          if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') continue;
          var r = e.getBoundingClientRect();
          if (r.height > 0 && r.top < window.innerHeight && r.bottom >= window.innerHeight - 2) max = Math.max(max, r.height);
        }
        var v = max ? max + 'px' : '0px';
        if (v !== lastLift) { lastLift = v; document.documentElement.style.setProperty('--aoam-mkt-lift', v); }
      }

      var liftTimer = null, liftRaf = 0, lastLift = null;
      // 2026-10-10 audit: re-measure on the next frame after a scroll, so the bar steps up the moment the sticky Add to Cart appears instead of up to 750ms later; it only writes the CSS variable when the height changed.
      function liftSoon() { if (liftRaf) return; liftRaf = requestAnimationFrame(function () { liftRaf = 0; lift(); }); }

      // 2026-10-12 audit L: under 768px the bar docks to the bottom of the header (which slides when the sticky header engages), so measure it now and again at 120ms and 420ms after a scroll or resize.
      var kickTimers = [];
      function dock() {
        var h = document.querySelector('.section-header__main');
        var top = 0;
        if (window.innerWidth < 768 && h) { var r = h.getBoundingClientRect(); top = Math.max(0, Math.round(r.bottom)); }
        document.documentElement.style.setProperty('--aoam-mkt-top', top + 'px');
      }
      function kick() {
        dock();
        kickTimers.forEach(clearTimeout);
        kickTimers = [setTimeout(dock, 120), setTimeout(dock, 420)];
      }

      function show(cc, info) {
        dock();
        lift();
        window.addEventListener('resize', lift, { passive: true });
        window.addEventListener('scroll', liftSoon, { passive: true });
        window.addEventListener('resize', kick, { passive: true });
        window.addEventListener('scroll', kick, { passive: true });
        // The SAVE 5% subscribe bar does not necessarily exist at the bottom yet when this fires, so
        // a single measurement is not enough - it has been observed both ways on the same build.
        // Re-measuring on a cheap timer is what actually keeps the two from overlapping.
        liftTimer = setInterval(lift, 750);
        host.hidden = false;
        host.className = 'aoam-mkt';
        host.setAttribute('role', 'region');
        host.setAttribute('aria-label', 'Shopping region');
        host.innerHTML =
          '<button type="button" class="aoam-mkt__x" aria-label="Close">&times;</button>' +
          '<p class="aoam-mkt__title">' + esc('Shipping to ' + info.name + '?').replace(/ ([^ ]*)$/, '&nbsp;$1') + '</p>' +
          '<p class="aoam-mkt__body">Prices are showing in ' + esc(data.currentCurrency) +
          '. Switch to ' + esc(info.currency) + '.</p>' +
          '<div class="aoam-mkt__row">' +
            '<button type="button" class="aoam-mkt__btn aoam-mkt__btn--go">Shop in ' + esc(info.currency) + '</button>' +
            '<button type="button" class="aoam-mkt__btn aoam-mkt__btn--no">Keep ' + esc(data.currentCurrency) + '</button>' +
          '</div>';

        lift(); // again once the markup is in, so the first paint is already at the right height

        function close() {
          remember(cc); host.hidden = true; host.innerHTML = '';
          document.removeEventListener('keydown', onKey);
          window.removeEventListener('resize', lift);
          window.removeEventListener('scroll', liftSoon);
          window.removeEventListener('resize', kick);
          window.removeEventListener('scroll', kick);
          kickTimers.forEach(clearTimeout); kickTimers = [];
          if (liftTimer) { clearInterval(liftTimer); liftTimer = null; }
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        document.addEventListener('keydown', onKey);
        host.querySelector('.aoam-mkt__x').addEventListener('click', close);
        host.querySelector('.aoam-mkt__btn--no').addEventListener('click', close);
        host.querySelector('.aoam-mkt__btn--go').addEventListener('click', function () {
          remember(cc);
          var f = document.createElement('form');
          f.method = 'post';
          f.action = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'localization';
          f.style.display = 'none';
          f.innerHTML =
            '<input type="hidden" name="form_type" value="localization">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="_method" value="put">' +
            '<input type="hidden" name="country_code" value="' + esc(cc) + '">' +
            '<input type="hidden" name="return_to" value="' + esc(location.pathname + location.search) + '">';
          document.body.appendChild(f);
          if (window.AOAM_LOAD) window.AOAM_LOAD.show();
          f.submit();
        });
      }

      function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      // The Shopify consent dialog is position:fixed at the bottom with z-index 2000000 and is up to
      // 451px tall on a phone (see the 2026-07-30 fix in theme.css). Stacking this bar under it would
      // be invisible, and stacking it over it would bury Accept/Decline. So we wait it out, and never
      // touch, hide or auto-answer the banner.
      function whenConsentClear(cb) {
        var tries = 0;
        (function poll() {
          // NOTE: the dialog is id="shopify-pc__banner" class="shopify-pc__banner__dialog" on this
          // store, NOT class "shopify-pc__banner". Matching the class alone finds nothing and the
          // gate releases immediately.
          var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog');
          var cs = b && getComputedStyle(b);
          var open = !!(b && cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0);
          if (!open) return cb();
          if (++tries > 90) return;
          setTimeout(poll, 2000);
        })();
      }

      function run() {
        fetch('/browsing_context_suggestions.json?country[enabled]=true', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
            if (!cc || cc === data.current) return;
            var info = data.countries[cc];
            if (!info) return;
            if (info.currency === data.currentCurrency) return;
            if (dismissed(cc)) return;
            whenConsentClear(function () { if (!dismissed(cc)) show(cc, info); });
          })
          .catch(function () {});
      }

      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 3000 });
      else setTimeout(run, 1500);
    })();
  